import React from 'react';
import { FluidTabs } from '../../ui/fluid-tabs';
import { ViewAllButton } from '../../ui/view-all-button';
import { HomeActivityCard } from './HomeActivityCard';
import { HomeProductRail } from './HomeProductRail';
import { useHomeActivities, type HomeActivitiesSeasonFilter } from './useHomeActivities';
import { WebCatalogUpdatingNotice } from '../WebCatalogUpdatingNotice';

const HomeActivities: React.FC = () => {
  const { t, seasonFilter, setSeasonFilter, featured, onBookActivity } = useHomeActivities();

  return (
    <section id="activities" className="home-product-type-section" style={{ background: '#e8ddd7' }}>
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 text-center md:mb-8">
          <h2
            className="font-felix-titling mb-3 text-3xl font-bold uppercase md:text-5xl"
            style={{
              letterSpacing: '-0.02em',
              color: 'rgba(30, 30, 30, 1)',
              fontWeight: 500,
            }}
          >
            {t('landing.activities.title') || 'Our Activities'}
          </h2>
          <p className="landing-section-subtitle">
            {t('landing.activities.subtitle') ||
              'Adventures for every season — fishing, kayaking, hiking and more'}
          </p>

          <FluidTabs
            tabs={[
              { id: 'all_year', label: t('common.allSeasons') || 'All year' },
              { id: 'summer', label: t('landing.activities.filterSummer') || 'Summer' },
              { id: 'winter', label: t('landing.activities.filterWinter') || 'Winter' },
            ]}
            activeTab={seasonFilter}
            onTabChange={(tabId) => setSeasonFilter(tabId as HomeActivitiesSeasonFilter)}
            className="mt-4"
          />
          <div className="mt-5 flex justify-center">
            <ViewAllButton
              to="/webdesigned/activities"
              label={t('landing.activities.viewAll') || 'View All Activities'}
            />
          </div>
        </div>
      </div>

      {featured.length > 0 ? (
        <HomeProductRail
          resetKey={seasonFilter}
          aria-label={t('landing.activities.title') || 'Activities'}
        >
          {featured.map((activity) => (
            <HomeActivityCard key={activity.id} activity={activity} t={t} onBookActivity={onBookActivity} />
          ))}
        </HomeProductRail>
      ) : (
        <div className="mx-auto max-w-7xl px-4">
          <WebCatalogUpdatingNotice />
        </div>
      )}
    </section>
  );
};

export default HomeActivities;
